import { useNavigate } from 'react-router-dom';

const usePageBack = (fallback = '/') => {
  const navigate = useNavigate();
  return () => {
    if (window.history.state?.idx > 0) navigate(-1);
    else navigate(fallback, { replace: true });
  };
};

export default usePageBack;
